__webpack_require__.p = "/interactive/intel/ai-with-purpose/";